const RIGHT_WING_POSES = [
  'M5 -5Q1.6 -15.9 7.6 -22.7Q15.3 -31 25 -36.7Q24.8 -32.9 27.3 -30Q25.4 -27.3 25.8 -24Q15.2 -20.8 9.7 -11.3Q2.2 -3.1 2.5 8Z',
  'M5 -5Q10.3 -15.1 19.4 -15.7Q33.2 -18.6 47.2 -15.2Q42.2 -9.9 42.2 -2.7Q36.2 -1.8 32.5 3Q25 -1 16.8 1.3Q8.3 1.8 2.5 8Z',
  'M5 -5Q15.6 -9.3 22.9 -3.9Q30.4 6.7 33.3 19.5Q27.5 17.6 22.1 20.2Q19.2 16.1 14.2 15.2Q12.8 11.6 9.4 10Q6.3 7.6 2.5 8Z',
  'M5 -5Q5.6 -16.4 13.5 -20.7Q22 -15.1 28.6 -7.6Q25.5 -7.1 23.5 -4.7Q20.9 -5.9 18.2 -5Q12.5 -4.8 8.6 -0.7Q3.8 2.4 2.5 8Z',
];

const LEFT_WING_POSES = [
  'M-5 -5Q-1.6 -15.9 -7.6 -22.7Q-15.3 -31 -25 -36.7Q-24.8 -32.9 -27.3 -30Q-25.4 -27.3 -25.8 -24Q-15.2 -20.8 -9.7 -11.3Q-2.2 -3.1 -2.5 8Z',
  'M-5 -5Q-10.3 -15.1 -19.4 -15.7Q-33.2 -18.6 -47.2 -15.2Q-42.2 -9.9 -42.2 -2.7Q-36.2 -1.8 -32.5 3Q-25 -1 -16.8 1.3Q-8.3 1.8 -2.5 8Z',
  'M-5 -5Q-15.6 -9.3 -22.9 -3.9Q-30.4 6.7 -33.3 19.5Q-27.5 17.6 -22.1 20.2Q-19.2 16.1 -14.2 15.2Q-12.8 11.6 -9.4 10Q-6.3 7.6 -2.5 8Z',
  'M-5 -5Q-5.6 -16.4 -13.5 -20.7Q-22 -15.1 -28.6 -7.6Q-25.5 -7.1 -23.5 -4.7Q-20.9 -5.9 -18.2 -5Q-12.5 -4.8 -8.6 -0.7Q-3.8 2.4 -2.5 8Z',
];

export const BAT_VIEW_BOX = '-50 -42 100 72';

export const BAT_BODY_PATH =
  'M-3.5 -16L0 -11.5L3.5 -16L4.6 -9.5C5.5 -7 5.6 -4 5.2 -1C4.8 3 3.2 7 0 12C-3.2 7 -4.8 3 -5.2 -1C-5.6 -4 -5.5 -7 -4.6 -9.5Z';

export const BAT_FOLDED_PATH =
  'M-3.5 -16L0 -11.5L3.5 -16L4.6 -9.8L7.6 -12.4C10.4 -7 10.8 1 8.8 7.6C6.8 12.6 3.2 15.4 0 16.2C-3.2 15.4 -6.8 12.6 -8.8 7.6C-10.8 1 -10.4 -7 -7.6 -12.4L-4.6 -9.8Z M-2 15.6L-1.4 18.6L-0.6 15.9Z M2 15.6L1.4 18.6L0.6 15.9Z';

export const BAT_RIGHT_WING = {
  restPath: RIGHT_WING_POSES[0],
  flapValues: [...RIGHT_WING_POSES, RIGHT_WING_POSES[0]].join(';'),
};

export const BAT_LEFT_WING = {
  restPath: LEFT_WING_POSES[0],
  flapValues: [...LEFT_WING_POSES, LEFT_WING_POSES[0]].join(';'),
};
